import reportCardValidationPopup from '../views/report-card-validation-popup.html';
class ReportCardListingCtrl {
    constructor($scope, $state, $mdDialog, authService, localStorageService, $rootScope, MARK_ENTRY_SAVE_CONSTANTS) {
        'ngInject';
        let self = this
        let authoring = localStorageService.get('authoringData')
        let userId = localStorageService.get('user_id')
        $rootScope.title = "Report Cards"
        let activeAcd = localStorage.getItem('activeAcdYear')
        if (!activeAcd) {
            activeAcd = localStorageService.get('activeAcdYear')
        }
        if (!activeAcd) {
            activeAcd = localStorageService.get('academic_year')
        }
        if (!activeAcd) {
            activeAcd = "2018-2019"
        }
        var rcListingYear = localStorageService.get('rcListingYear')
        if (rcListingYear) {
            // console.log(rcListingYear)
        }
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
            if (!$rootScope.isLoggedIn) {
              $state.go("login", {}, { reload: true })
            }
            pushLog();
        }
		// $rootScope.reportExist= {
		// 	"data_exist": true,
		// 	"console_id": "periodicTestOneNoConversion"
		// }
		// console.log($rootScope.reportExist,"$rootScope.reportExist");
        $scope.sessionName = authoring.session
        $scope.curiculumName = authoring.curriculum
        $scope.className = authoring.class
        $scope.batchName = authoring.batch
        $scope.subjectName = authoring.subject
        this.featureMoreThanOne = false
        this.report_console = true
        this.approve_reject = false
        $scope.loading = true
        self.selected_year = undefined
        if (activeAcd) {
            if (rcListingYear) {
                self.selected_year = rcListingYear
            } else {
                self.selected_year = activeAcd
            }
            subscribeAndMakeFunction(self.selected_year)
        }
        let subjectId = undefined
        let sessionId = undefined
        let curriculumId = undefined
        let xClassId = undefined
        let batchId = undefined
        let schoolId = undefined
        if (authoring) {
            subjectId = authoring.subject_id
            sessionId = authoring.session_id
            curriculumId = authoring.curriculum_id
            xClassId = authoring.class_id,
                batchId = authoring.batch_id,
                schoolId = authoring.school_id
        }
        $scope.isBucketSelection = false;
		$scope.autoGenertion = false;
        if (MARK_ENTRY_SAVE_CONSTANTS.KG_CLASSES.includes(authoring.class_id))
            $scope.isBucketSelection = true;
		else
		    $scope.autoGenertion = true;

        function subscribeAndMakeFunction(selected_year) {
            let obj = {
                authoring: authoring,
                selected_year: selected_year,
                activeAcd: activeAcd,
                my_user_id: userId
            }
            authService.callAPI("/v0/reportcards/teacher/list", "POST",
                { args: obj, subject_id: authoring.subject_id }, function (response) {

                    if (response && response.result && response.result.data && response.result.data.details) {
                        let schoolDataSub = response.result.data.details.response.permissions.schooldata
                        let personData = response.result.data.details.response.permissions.personData
                        self.scData = schoolDataSub.academic_year
                        let acdYear = _.find(schoolDataSub.academic_year, function (oneY) {
                            return oneY.status == 'active'
                        })
                        let featuresAll = personData.feature_privileges
                        if (featuresAll) {
                            self.reportCardListArray = response.result.data.details.response.rcData
							for(let i=0;i< self.reportCardListArray.length;i++){

								// if(self.reportCardListArray[i]  && $rootScope.reportExist && $rootScope.reportExist.data_exist && self.reportCardListArray[i]._id == $rootScope.reportExist.console_id){
								// 	self.reportCardListArray[i].is_pending = true
								// 	//  $rootScope.reportExist.data_exist = false
								// }else{
								// 	self.reportCardListArray[i].is_pending = false
								// }
							}
                        } else {
                            $state.go("dashboard")
                        }

                        $scope.loading = false
                        _.defer(function () { $scope.$apply(); });
                    }
                })
        }

        self.listRcWithSelectedYear = (selected_year) => {
            self.selected_year = selected_year
            localStorageService.set({
                rcListingYear: selected_year
            })
            $scope.loading = true
            subscribeAndMakeFunction(self.selected_year)
        }

        function verifyData(result, cardId) {
			// $scope.loading = true
            if (!result || !result.response) {
                if ($scope.isBucketSelection)
                   { kgReportCheck(cardId)}
				else if ( $scope.autoGenertion){
                     mainReportCheck(cardId)
				}else  {$state.go('reportCardGenConsole', {
                        cardId: cardId,
                        dataId: false,
                        re_generate: false,
                        fromCt: false
                    })}
            } else {
                if (result.response && result.response._id) {
                    if (result.response.current_status && result.response.current_status.status == "rejected") {
                        if ($scope.isBucketSelection){
							kgReportCheck(cardId)
						}
                          else if ( $scope.autoGenertion){
                     mainReportCheck(cardId)
				}
                        else{  $state.go('reportCardGenConsole', {
							cardId: cardId,
							dataId: result.response._id,
							re_generate: false,
							fromCt: false
						})}

                    } else {
                        $state.go('viewGeneratedReportData', {
                            dataId: result.response._id,
                            selected_year: self.selected_year,
                            is_edit : false
                        })
                    }
                } else {
                    if ($scope.isBucketSelection){
						kgReportCheck(cardId)
					}
                     else if ( $scope.autoGenertion){
                     mainReportCheck(cardId)
				}
                    else{ $state.go('reportCardGenConsole', {
						cardId: cardId
					})}

                }
            }
        }

        self.syncReportCard = (card)=>{
            if(!card.mark_entry_updated){
              toastr.success('Report Card is already up to date with the latest mark entry')
              return
            }
            syncReportCheck(card)
          }
          function syncReportCheck(card) {
			let api_url = "/v0/reportcards/teacher/main/autogenerate"
			if(card.kg_rc || card.montessori_rc){
				api_url = MARK_ENTRY_SAVE_CONSTANTS.API_AUTO_GENERATE_KG_REPORT
			}
            let st = "Are you sure you want to sync the report card with latest mark entry?"
                  let confirm = $mdDialog
                      .confirm()
                      .title(st)
                      .ok("Yes")
                      .cancel("No");
                  $mdDialog.show(confirm).then(
                      function () {
                $scope.loading= true
                          let reqObj = {
                  session: authoring.session_id,
                  curriculum: authoring.curriculum_id,
                  class: authoring.class_id,
                  batch: authoring.batch_id,
                  subject:authoring.subject_id,
                  school_id: schoolId,
                  academic_year: activeAcd,
                  report_console_id: card._id
                }

                authService.callAPI(api_url, 'POST', reqObj, function (response) {
                  if (response.result && response.result.data && response.result.data.details) {
                    let reqArr = [];
                    _.each(response.result.data.details, function (data) {
						if(card.kg_rc || card.montessori_rc){
							reqArr.push({
								aliace: data.bucket.db_key,
								db_key: data.bucket.db_key,
								list: [{
									activity_name: data.mark_entry_details.exam,
									activity_id: data.mark_entry_details._id,
									created_by: userId,
									type: "activities"
								}],
								// max_mark: data.bucket.max_mark,
								max_mark: 100,
								name: data.bucket.name,
								selection: "best"
							});
						}else{
							console.log("ooooooooo+++++++");
							reqArr.push({
								aliace: data.bucket.aliace,
								db_key: data.bucket.db_key,
								list: [{
								  activity_name: data.markEntryDetail.exam,
								  activity_id: data.markEntryDetail._id,
								  created_by: userId,
								  type: "activities"
								}],
								 max_mark: data.bucket.max_mark,
								// max_mark: 100,
								name: data.bucket.name,
								selection: "best"
							  });
						}

                    });
                    let activityCondition = {
                      session_id: authoring.session_id,
                      curriculum_id: authoring.curriculum_id,
                      class_id: authoring.class_id,
                      batch_id: authoring.batch_id,
                      subject_id: authoring.subject_id,
                      school_id: schoolId,
                    }
                    let reqObj = {
                      args: {
                        cardId: card._id,
                        report_card_id:card.report_data_id,
                        valuesUnderSkills: reqArr,
                        activityCondition: activityCondition,
                        dataId: false,
                        re_generateFlag: false,
                        fromCt: false,
                        select_regen: false,
                        get_students_selected: [],
                        myUserId: userId,
                        report_card_sync:true
                      }
                    }
                    console.log(reqObj);
                    authService.callAPI(MARK_ENTRY_SAVE_CONSTANTS.API_REPORT_CARD_GENERATE, 'POST', reqObj, function (response) {
                      try {
                        if (response.error && response.error.error == "Already generated the report!") {
                          toastr.error(response.error.error);
                        } else {
                          let result = response.result.data.details.response;
                          card.mark_entry_updated = false;
                          toastr.success("Report card is updated with latest mark entry")

                        }
                        $scope.loading = false
                        $scope.$apply()
                      } catch (ex) {
                        console.log(ex);
                      }
                    })
                  } else if (response.error && response.error.error && response.error.error.message) {
                      $scope.loading = false
                    $mdDialog.show(
                      $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .title('Alert!')
                        .textContent(response.error.error.message)
                        .ariaLabel('Alert Dialog Demo')
                        .ok('OK')
                    );
                   }
                });
                      },
                      function () { }
                  );


              }
        self.viewTemplate = (cardId, view_only) => {
			// $scope.loading = true
            $scope.templateCard = _.find(self.reportCardListArray, function (rec) {
                return rec._id == cardId
            })
            if (subjectId && sessionId && curriculumId && xClassId && cardId && batchId && schoolId) {
                var activityCondition = {
                    subject_id: subjectId,
                    session_id: sessionId,
                    curriculum_id: curriculumId,
                    class_id: xClassId,
                    batch_id: batchId,
                    school_id: schoolId
                }
                let page = false
                let toServer = {
                    cardId: cardId,
                    conditions: activityCondition,
                    page: page,
                    isFromListingPage: true,
                    re_generateFlag: false,
                    fromCt: false,
                    fromView: true,
                    passedYear: self.selected_year
                }
                authService.callAPI("/v0/reportcards/teacher/validation", "POST",
                    { args: toServer }, function (response) {
                        try {
                            if (!response.error) {
                                let result = response.result.data.details
                                verifyData(result, cardId)
                            } else {
                                if (response.error.error && response.error.error.error) {
                                    toastr.error(response.error.error.error)
                                }
                            }
                        } catch (e) {
                            console.log(e)
                        }
                    })
            }
        }

        self.viewActivities = (cardId, report_data_id, card) => {
            let activityCondition = {
                "subject_id": subjectId,
                "session_id": sessionId,
                "curriculum_id": curriculumId,
                "class_id": xClassId,
                "batch_id": batchId,
                "school_id": schoolId
            }
            let toServer = {
                cardId: cardId,
                report_data_id: report_data_id,
                acdCondition: activityCondition
            }
            authService.callAPI("/v0/reportcards/teacher/viewActivitiesRc", "POST",
                { args: toServer }, function (response) {
                    if (response.result) {
                        let data = response.result.data.details.response
                        if (data && data.buckets.length) {
                            $mdDialog.show({
                                controller: ['$scope', '$mdDialog', 'data', validationCtrl],
                                locals: {
                                    "data": data,

                                },
                                template: reportCardValidationPopup,
                                parent: angular.element(document.body),
                                clickOutsideToClose: true,
                            })
                        }
                    }
                })
        }

        function kgReportCheck(console_id) {
			let st = "Are you sure you want to proceed ?"
            let confirm = $mdDialog
                .confirm()
                .title(st)
                .ok("Generate")
                .cancel("Cancel");
            $mdDialog.show(confirm).then(
                function () {
					let reqObj = {
						session: sessionId,
						curriculum: curriculumId,
						class: xClassId,
						batch: batchId,
						subject: subjectId,
						school_id: schoolId,
						academic_year: activeAcd,
						report_console_id: console_id
					}
					$scope.loading= true
					authService.callAPI(MARK_ENTRY_SAVE_CONSTANTS.API_AUTO_GENERATE_KG_REPORT, 'POST', reqObj, function (response) {
						if (response.result && response.result.data && response.result.data.details) {
							let reqArr = [];
							_.each(response.result.data.details, function (data) {
								reqArr.push({
									aliace: data.bucket.db_key,
									db_key: data.bucket.db_key,
									list: [{
										activity_name: data.mark_entry_details.exam,
										activity_id: data.mark_entry_details._id,
										created_by: userId,
										type: "activities"
									}],
									// max_mark: data.bucket.max_mark,
									max_mark: 100,
									name: data.bucket.name,
									selection: "best"
								});
							});
							let activityCondition = {
								subject_id: subjectId,
								session_id: sessionId,
								curriculum_id: curriculumId,
								class_id: xClassId,
								batch_id: batchId,
								school_id: schoolId
							}
							let reqObj = {
								args: {
									cardId: console_id,
									valuesUnderSkills: reqArr,
									activityCondition: activityCondition,
									dataId: false,
									re_generateFlag: false,
									fromCt: false,
									select_regen: false,
									get_students_selected: [],
									myUserId: userId
								}
							}
							authService.callAPI(MARK_ENTRY_SAVE_CONSTANTS.API_REPORT_CARD_GENERATE, 'POST', reqObj, function (response) {
								try {
									if (response.error && response.error.error == "Already generated the report!") {
										toastr.error(response.error.error);
									} else {
										let result = response.result.data.details.response;
										if (result) {
											toastr.success("Auto Generated the report");
											if (result._id._id) {
												$state.go('viewGeneratedReportData', {
													dataId: result._id._id,
													selected_year: activeAcd,
													is_edit : false
												});
											} else {
												$state.go('viewGeneratedReportData', {
													dataId: result._id,
													selected_year: activeAcd,
													is_edit : false
												});
											}
										}
									}
								} catch (ex) {
									console.log(ex);
								}
							})
						} else if (response.error && response.error.error && response.error.error.message) {
							$scope.loading = false
							$mdDialog.show(
								$mdDialog.alert()
									.clickOutsideToClose(true)
									.title('Alert!')
									.textContent(response.error.error.message)
									.ariaLabel('Alert Dialog Demo')
									.ok('OK')
							);
						}
					});
				})

        }

		function pushLog(){
            let userId = localStorageService.get('user_id');
            let schoolId = localStorageService.get('school_id');
            authService.callRabbitMQAPI("/v0/rabbitmqpush/"+userId+"/"+schoolId+"/reportCardTeacherList", "GET", {},function (response) {
            // console.log(response)
			});
		}

		function mainReportCheck(console_id) {
			let st = "Are you sure you want to proceed ?"
            let confirm = $mdDialog
                .confirm()
                .title(st)
                .ok("Generate")
                .cancel("Cancel");
            $mdDialog.show(confirm).then(
                function () {
					$scope.loading= true
                    let reqObj = {
						session: sessionId,
						curriculum: curriculumId,
						class: xClassId,
						batch: batchId,
						subject: subjectId,
						school_id: schoolId,
						academic_year: activeAcd,
						report_console_id: console_id
					}
					authService.callAPI("/v0/reportcards/teacher/main/autogenerate", 'POST', reqObj, function (response) {
						if (response.result && response.result.data && response.result.data.details) {
							let reqArr = [];
							_.each(response.result.data.details, function (data) {
								if(data && data.bucket){
									reqArr.push({
										aliace: data.bucket.aliace,
										db_key: data.bucket.db_key,
										list: [{
											activity_name: data.markEntryDetail.exam,
											activity_id: data.markEntryDetail._id,
											created_by: userId,
											type: "activities"
										}],
										 max_mark: data.bucket.max_mark,
										// max_mark: 100,
										name: data.bucket.name,
										selection: "best"
									});
								}else{
									reqArr.push({

										list: [{
											activity_name: data.markEntryDetail.exam,
											activity_id: data.markEntryDetail._id,
											created_by: userId,
											type: "activities"
										}],

										selection: "best"
									});
								}

							});
							let activityCondition = {
								subject_id: subjectId,
								session_id: sessionId,
								curriculum_id: curriculumId,
								class_id: xClassId,
								batch_id: batchId,
								school_id: schoolId
							}
							let reqObj = {
								args: {
									cardId: console_id,
									valuesUnderSkills: reqArr,
									activityCondition: activityCondition,
									dataId: false,
									re_generateFlag: false,
									fromCt: false,
									select_regen: false,
									get_students_selected: [],
									myUserId: userId
								}
							}

							authService.callAPI(MARK_ENTRY_SAVE_CONSTANTS.API_REPORT_CARD_GENERATE, 'POST', reqObj, function (response) {
								try {
									if (response.error && response.error.error == "Already generated the report!") {
										toastr.error(response.error.error);
									} else {
										let result = response.result.data.details.response;
										if (result) {
											toastr.success("Auto Generated the report");
											if (result._id._id) {
												$state.go('viewGeneratedReportData', {
													dataId: result._id._id,
													selected_year: activeAcd,
													is_edit : false
												});
											} else {
												$state.go('viewGeneratedReportData', {
													dataId: result._id,
													selected_year: activeAcd,
													is_edit : false
												});
											}
										}
									}
								} catch (ex) {
									console.log(ex);
								}
							})
						} else if (response.error && response.error.error && response.error.error.message) {
							  $scope.loading = false
							$mdDialog.show(
								$mdDialog.alert()
									.clickOutsideToClose(true)
									.title('Alert!')
									.textContent(response.error.error.message)
									.ariaLabel('Alert Dialog Demo')
									.ok('OK')
							);
					   }
					});
                },
                function () { }
            );


        }
    }
}

class validationCtrl {
    constructor($scope, $mdDialog, data) {
        $scope.data = data
        $scope.cancel = () => {
            $mdDialog.cancel()
            $mdDialog.hide()
        }
    }
}

export default ReportCardListingCtrl;



// WEBPACK FOOTER //
// ./src/app/report_cards/teacher/controllers/reportcardController.js